module.exports = __webpack_public_path__ + "img/04.a16ac57a.jpg";